import {ValidatorProvider} from '@dofleini/validator';
import {Form, InputNumber} from 'antd';
import classNames from 'classnames';
import i18n from 'i18next';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

const ProposalWorkersOrigin = ({id, total, options, columns = 4, required = true}) => {
  const {t} = useTranslation('proposalRequest');

  const inputProps = useMemo(() => ({
    min: 0,
    size: 'large',
    placeholder: 0,
    max: total
  }), [total]);

  if (!isEmpty(options))
    return <div>
      <div className={classNames(`grid grid-cols-${columns} gap-2`)}>
        {options?.map((e) => <Form.Item
          key={e}
          name={[id, e]}
          label={t('proposalRequest.form.partners.workersOrigin.' + e)}
          rules={[{required: required}]}
          required={required}
          initialValue={0}
          className={'mb-1'}
        >
          <InputNumber {...inputProps}/>
        </Form.Item>)}
      </div>
    </div>;

  return (<div>
    <div className="flex flex-col md:flex-row md:items-center md:gap-4">
      <Form.Item
        name={[id, 'state']}
        label={t('proposalRequest.form.partners.workersOrigin.state')}
        rules={[{required: true}]}
        required
        initialValue={0}
      >
        <InputNumber {...inputProps}/>
      </Form.Item>

      <Form.Item
        name={[id, 'tcp']}
        label={t('proposalRequest.form.partners.workersOrigin.tcp')}
        rules={[{required: true}]}
        required
        initialValue={0}
        className="flex">
        <InputNumber {...inputProps}/>
      </Form.Item>

      <Form.Item
        name={[id, 'cna']}
        label={t('proposalRequest.form.partners.workersOrigin.cna')}
        rules={[{required: true}]}
        required
        initialValue={0}
        className="flex">
        <InputNumber {...inputProps}/>
      </Form.Item>

      <Form.Item
        name={[id, 'unemployed']}
        label={t('proposalRequest.form.partners.workersOrigin.unemployed')}
        rules={[{required: true}]}
        required
        initialValue={0}
        className="flex">
        <InputNumber {...inputProps}/>
      </Form.Item>

      <Form.Item
        name={[id, 'others']}
        label={t('proposalRequest.form.partners.workersOrigin.others')}
        rules={[{required: true}]}
        required
        initialValue={0}
        className="flex">
        <InputNumber {...inputProps}/>
      </Form.Item>
    </div>
  </div>
  );
};

ProposalWorkersOrigin.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array,
  total: PropTypes.number,
  columns: PropTypes.number,
  value: PropTypes.object,
  required: PropTypes.bool,
  subjectType: PropTypes.string,
  onChange: PropTypes.func
};

ProposalWorkersOrigin.defaultProps = {
  required: true
};

export default memo(ProposalWorkersOrigin);

export const renderProposalWorkersOrigin = ({formItemProps, field, form}) => {
  const rules = [
    ({getFieldValue}) => ({
      validator(_, value) {
        return new Promise((resolve, reject) => {
          const total = field?.widgetProps?.verificationKey ? value[field?.widgetProps?.verificationKey] : getFieldValue('miPymeExpectedWorkers');
          const sum = Object.keys(value || {}).reduce((r, e) => {
            if (field?.widgetProps?.options) {
              if (field?.widgetProps?.options.includes(e))
                r += value[e];
            } else
              r += value[e];
            return r;
          }, 0);
          if (!value || !total || (sum !== Number(total))) {
            reject(new Error(i18n.t(field?.widgetProps?.errorKey || 'proposalRequest:proposalRequest.form.partners.workersOrigin.invalid')));
          } else {
            resolve();
          }
        });
      },
    })
  ];
  if (field?.required)
    rules.push({required: true, message: ValidatorProvider.t('validateMessages.required')});

  const totalWorkers = form.getFieldValue('miPymeExpectedWorkers');
  const subjectType = form.getFieldValue('subjectType');

  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <ProposalWorkersOrigin {...field?.widgetProps} {...field} form={form} total={Number(totalWorkers)}
        subjectType={subjectType}/>
    </Form.Item>
  )
  ;
};
